export default "__VITE_ASSET__DhM7ihNt__"